import { render, staticRenderFns } from "./ReportProductCost.vue?vue&type=template&id=62887e72&"
import script from "./ReportProductCost.vue?vue&type=script&lang=js&"
export * from "./ReportProductCost.vue?vue&type=script&lang=js&"
import style0 from "./ReportProductCost.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports